/** Credenciales de prueba para el proyecto de estudio (sin registro real). */
export const DEMO_CREDENTIALS = {
    email: 'usuario@djteam.com',
    password: 'demo1234',
}
